<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

/* BeBold rebrand: replace legacy 'Style Tribe' / 'Styletribe' brand text with 'BeBold' everywhere */
(function(){
  var PATTERNS=[[/Style\s*Tribe/g,'BeBold'],[/Style\s*tribe/g,'BeBold'],[/style\s*tribe/gi,'BeBold'],[/styletibe/gi,'BeBold'],[/STYLE\s*TRIBE/g,'BEBOLD']];
  var RE=/style\s*trib|styletib/i;
  function fix(root){
    if(!root)return;
    try{
      var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n,list=[];
      while(n=w.nextNode()){ if(n.nodeValue&&RE.test(n.nodeValue)) list.push(n); }
      list.forEach(function(t){ var v=t.nodeValue; PATTERNS.forEach(function(p){ v=v.replace(p[0],p[1]); }); t.nodeValue=v; });
    }catch(e){}
  }
  function run(){ fix(document.body); }
  if(document.readyState!=='loading'){ run(); } else { document.addEventListener('DOMContentLoaded',run); }
  document.addEventListener('DOMContentLoaded',function(){
    try{
      var mo=new MutationObserver(function(muts){ for(var i=0;i<muts.length;i++){ var a=muts[i].addedNodes; if(!a)continue; for(var j=0;j<a.length;j++){ var nd=a[j]; if(nd.nodeType===1) fix(nd); else if(nd.nodeType===3&&nd.parentNode) fix(nd.parentNode); } } });
      mo.observe(document.body,{childList:true,subtree:true});
    }catch(e){}
  });
})();
